import { Stack, Box, Typography } from '@mui/material';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { format, parse } from 'date-fns';

interface ViewDateTimeDetailsProps {
  date: string;         // e.g. "2025-04-14"
  from_time: string;    // e.g. "14:00"
  to_time: string;      // e.g. "15:30"
  timezone: string;     // e.g. "PDT", "EST", or "IST"
  updated_at?: string;  // ISO string or similar
}

const formatTimeRange = (date: string, from_time: string, to_time: string, timezone: string) => {
  try {
    const fromDateTime = parse(`${date} ${from_time}`, 'yyyy-MM-dd HH:mm', new Date());
    const toDateTime = parse(`${date} ${to_time}`, 'yyyy-MM-dd HH:mm', new Date());

    const formattedFrom = format(fromDateTime, 'hh:mm a');
    const formattedTo = format(toDateTime, 'hh:mm a');

    return `${formattedFrom} - ${formattedTo} ${timezone}`;
  } catch (err) {
    return '';
  }
};

const ViewDateTimeDetails: React.FC<ViewDateTimeDetailsProps> = ({
  date,
  from_time,
  to_time,
  timezone,
  updated_at,
}) => {
  return (
    <ShPaper variant="outlined">
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={5}
          alignItems="center"
          justifyContent="space-between"
          width="95%"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <EventIcon color="primary" fontSize="medium" />
            <Box>
              <Typography variant="body1" color="black" fontWeight={600}>
                Date
              </Typography>
              <Typography variant="body2" color="gray">
                {format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')}
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <AccessTimeIcon color="primary" fontSize="medium" />
            <Box>
              <Typography variant="body1" color="black" fontWeight={600}>
                Time
              </Typography>
              <Typography variant="body2" color="gray">
                {formatTimeRange(date, from_time, to_time, timezone)}
              </Typography>
            </Box>
          </Stack>
        </Stack>

        {updated_at && (
          <Stack direction="row" alignItems="center" spacing={1}>
            <EventIcon color="primary" fontSize="medium" />
            <Box>
              <Typography variant="body1" color="black" fontWeight={600}>
                Completed At
              </Typography>
              <Typography variant="body2" color="gray">
                {format(new Date(updated_at), 'dd MMM yyyy, hh:mm a')}
              </Typography>
            </Box>
          </Stack>
        )}
      </Stack>
    </ShPaper>
  );
};

export default ViewDateTimeDetails;
